// extracted by mini-css-extract-plugin
module.exports = {"container":"RouteUnavailableFallback_container__SMQp1"};